import React, { Component } from "react";
import AdminVideos from "../Videos/Videos";

class AdminLearningVideos extends Component {
  render() {
    return <AdminVideos learning {...this.props} />;
  }
}

export default AdminLearningVideos;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/LearningVideos/LearningVideos.js